export default function StrengthsSection() {
  return (
    <section id="strengths" className="py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-sm font-medium text-accent-600 tracking-wider mb-3">
            ヴェリテの強み
          </p>
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950">
            選ばれる理由
          </h2>
        </div>

        {/* Strengths Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {strengths.map((item, idx) => (
            <div
              key={idx}
              className="group p-6 md:p-8 bg-background-50 rounded-2xl border border-background-300 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 rounded-xl bg-accent-100 flex items-center justify-center mb-6 group-hover:bg-accent-500 transition-colors duration-300">
                <i className={`${item.icon} text-2xl text-accent-600 group-hover:text-background-50 transition-colors duration-300`} />
              </div>
              <h3 className="font-heading font-bold text-lg text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Visual — Sendai banner */}
        <div className="mt-16 relative overflow-hidden rounded-2xl aspect-[21/9] md:aspect-[21/7]">
          <img
            src="https://readdy.ai/api/search-image?query=Sendai%20cityscape%20panorama%20with%20modern%20buildings%20and%20traditional%20Japanese%20elements%2C%20warm%20golden%20hour%20sunset%20light%2C%20Miyagi%20prefecture%20urban%20landscape%20with%20mountains%20in%20background%2C%20editorial%20photography%20with%20soft%20warm%20tones%20and%20atmospheric%20perspective&width=1600&height=500&seq=verite-strength-banner&orientation=landscape"
            alt="Sendai City"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/20 to-transparent" />
          <div className="absolute inset-0 flex items-center px-8 md:px-12">
            <div className="max-w-lg">
              <p className="text-white text-lg md:text-xl font-medium leading-relaxed">
                Webもデザインも事務作業も、
                <br />
                <span className="text-accent-400">仙台の中小企業にとって気軽に頼める制作パートナー</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const strengths = [
  {
    title: 'フライズグループの安心感',
    desc: '福祉・就労支援に取り組むフライズグループの一員として、社会的責任を持った運営をしています。信頼できるパートナーとして長くお付き合いいただけます。',
    icon: 'ri-building-2-line',
  },
  {
    title: '仙台の窓口が一括対応',
    desc: '制作から保守管理まで、仙台のチームが一貫して対応。遠方の業者に依頼する必要がなく、打ち合わせもスムーズです。',
    icon: 'ri-map-pin-2-line',
  },
  {
    title: 'わかりやすい料金体系',
    desc: '追加料金の心配がない明朗会計。中小企業にとって予算を立てやすい、わかりやすい価格設定です。',
    icon: 'ri-price-tag-3-line',
  },
  {
    title: '地域に根ざした対応',
    desc: '仙台・宮城県の中小企業を主な対象とし、地域の事情や文化を理解した丁寧な対応を心がけています。',
    icon: 'ri-community-line',
  },
];